import React, { memo } from "react";
import * as Styles from "./radio-button.styles";

export const RadioButton = memo(({ name, label, value, onChange, checked }) => (
  <Styles.Label>
    <Styles.Button
      name={name}
      value={value}
      onChange={onChange}
      checked={checked}
    />
    {label}
  </Styles.Label>
));
